var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isAuthenticated)?[_c('DuelChallenge_Actions_Unauthenticated')]:(_vm.isChallenger)?[_c('DuelChallenge_Actions_Challenger',{attrs:{"duel":_vm.duel}})]:[_c('DuelChallenge_Actions_Challenged',{attrs:{"duel":_vm.duel}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }